import {
  AddRounded,
  CloseOutlined,
  CurrencyExchangeOutlined,
  DeleteOutline,
  EditNoteOutlined,
  EditOutlined,
  NewspaperOutlined,
  ReceiptLongOutlined,
} from "@mui/icons-material";
import { Box, Button, Card, IconButton, Tooltip } from "@mui/material";
import { get, isEmpty, isFunction, isNil } from "lodash";
import { useMemo, useState } from "react";

import { blueGrey, grey } from "@mui/material/colors";
import { useFormState } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffDollarField from "../components/finalForm/inputs/RffDollarField";
import RffFileUploadField from "../components/finalForm/inputs/RffFileUploadField";
import RffNumberField from "../components/finalForm/inputs/RffNumberField";
import RffPercentField from "../components/finalForm/inputs/RffPercentField";
import RffTextareaField from "../components/finalForm/inputs/RffTextareaField";
import RffTextField from "../components/finalForm/inputs/RffTextField";
import RffGroup from "../components/finalForm/shared/RffGroup";
import InputWrapper from "../components/inputs/shared/InputWrapper";
import Flx from "../components/layout/Flx";
import Txt from "../components/typography/Txt";
import TitledLoanSection from "../screens/NewFinancingRequestScreen/TitledLoanSection";
import { formatDollar } from "../utils/numbers/formatDollar";

import { useSelector } from "react-redux";
import RffSelectToggleField from "../components/finalForm/inputs/RffSelectToggleField";
import RffForm from "../components/finalForm/RffForm";
import SelectInput from "../components/inputs/SelectInput";
import { useEndpointHook } from "../hooks/useEndpointHook";

const LoanDrawRequestForm = ({ children }) => {
  const { loading, submitDrawRequest } = useEndpointHook();
  const [dealId, setDealId] = useState(null);
  const financingRequests = useSelector((state) => state?.financingRequests);

  const financingRequestsOptions = useMemo(() => {
    return financingRequests?.map((fr) => ({
      label: `${fr.loanName}  (${fr.loanProductType} - ${fr.loanPurpose})`,
      value: fr._id,
    }));
  }, [financingRequests]);
  const handleOnSumbit = (formData) => {
    submitDrawRequest({
      dealId,
      data: formData,
      onSuccessFn: (d) => {
        console.log("Successfully submitted draw request", d);
      },
    });
  };
  return (
    <RffForm
      // formSpy
      footerSx={{ mt: 2 }}
      alternativeLabel={false}
      submitText="Submit Request Draw"
      onSubmit={handleOnSumbit}
      loading={loading}
      // initialValues={initTest}
      // initialValues={{ reimbursementItemsRequested: [{}] }}
    >
      <Flx column gap={3}>
        <TitledLoanSection
          icon={<CurrencyExchangeOutlined className="thin" />}
          variant="h3"
          title="Select Loan"
          collapsable
        >
          <InputWrapper label="Select a Loan for your Draw Request">
            <SelectInput
              value={dealId}
              options={financingRequestsOptions}
              onChange={setDealId}
            />
          </InputWrapper>
        </TitledLoanSection>
        <TitledLoanSection
          icon={<NewspaperOutlined className="thin" />}
          variant="h3"
          title="Draw Request Details"
          collapsable
        >
          <RffGroup suppressBottomMargin stepName="Draw Request Details">
            {/* ---------- */}

            <RffDollarField
              label={"Requested Draw Amount"}
              name={"drawRequestedAmount"}
              size={4}
            />

            <RffPercentField
              size={4}
              label={"Percent Complete"}
              name={"percentComplete"}
            />
            <RffDateField
              label={"Request Date"}
              name={"requestDate"}
              size={4}
            />

            <RffFileUploadField
              suppressButton
              height="100px"
              label={"Supporting Documents"}
            />
          </RffGroup>
        </TitledLoanSection>
        <TitledLoanSection
          icon={<ReceiptLongOutlined className="thin" />}
          variant="h3"
          title="Reimbursement Items Requested"
          collapsable
        >
          <RffListItem
            stepName="Reimbursement Items"
            name={"reimbursementItemsRequested"}
          />
        </TitledLoanSection>
      </Flx>
    </RffForm>
  );
};

const RffListItem = ({ label, name }) => {
  const { values } = useFormState();
  const [indx, setIndx] = useState(null);

  const nameArray = get(values, name);
  const hideTable = isEmpty(nameArray);
  return (
    <RffGroup disableGrid suppressBottomMargin title={label}>
      <FieldArray name={name}>
        {({ fields: arrayFields, meta }) => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // gap: 2,
                // mt: -1,
                borderRadius: "4px",
                // background: grey[100],
              }}
            >
              {hideTable
                ? null
                : arrayFields.map((fieldName, index) => (
                    <Box
                      key={fieldName}
                      sx={{
                        position: "relative",
                        flexGrow: 1,
                        // overflow: "hidden",
                        borderLeft:
                          index === indx
                            ? `4px solid ${blueGrey[400]}`
                            : "none",
                        // border: "1px solid rgba(221, 224, 228, 0.77)",
                        borderBottom: "2px dashed #dde0e4",
                        // borderRadius: "4px",
                        p: 2,
                        // pr: 1,
                        // pt: 0,
                        backgroundColor: index === indx ? grey[100] : "none",

                        // pb: 2,
                      }}
                    >
                      <Flx fw jb gap={4}>
                        <Flx column gap={0}>
                          <Flx ac gap={1.2}>
                            <RffDisplayItem
                              name={`${fieldName}.itemName`}
                              emptyValue={"Example Item Name"}
                            />
                            {isNil(
                              get(values, `${fieldName}.quantityRequired`),
                            ) ? null : (
                              <Flx ac gap={0.3}>
                                <RffDisplayItem
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: "12px",
                                    color: grey[500],
                                  }}
                                  name={`${fieldName}.quantityRequired`}
                                  emptyValue={"0"}
                                />
                                <CloseOutlined
                                  className="thin"
                                  sx={{
                                    fontSize: "13px",
                                    // fontSize: "12px",
                                    color: grey[500],
                                  }}
                                />
                                <RffDisplayItem
                                  type={"dollar"}
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: grey[500],
                                  }}
                                  name={`${fieldName}.unitPrice`}
                                  emptyValue={"0"}
                                />
                              </Flx>
                            )}
                          </Flx>
                          <RffDisplayItem
                            secondary
                            name={`${fieldName}.description`}
                          />
                        </Flx>

                        <Flx ac gap={0}>
                          <Txt
                            sx={{ fontWeight: 500, color: grey[800], mr: 1 }}
                          >
                            {formatDollar(
                              get(values, `${fieldName}.unitPrice`) ||
                                0 *
                                  (get(
                                    values,
                                    `${fieldName}.quantityRequired`,
                                  ) || 0),
                            )}
                          </Txt>

                          <Tooltip title="Edit Line Item">
                            <IconButton
                              onClick={() => setIndx(index)}
                              size="small"
                            >
                              <EditOutlined fontSize="small" className="thin" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Line Item">
                            <IconButton
                              color="error"
                              onClick={() => {
                                arrayFields.remove(index);
                                setIndx(null);
                              }}
                              size="small"
                            >
                              <DeleteOutline
                                fontSize="small"
                                className="thin"
                              />
                            </IconButton>
                          </Tooltip>
                        </Flx>
                      </Flx>
                      {indx === index ? (
                        <LineItemEditingCard
                          name={name}
                          index={indx}
                          onClose={hideTable ? null : () => setIndx(null)}
                        />
                      ) : null}
                    </Box>
                  ))}

              <Flx
                center
                fw
                item
                sx={{
                  mt: 1,
                  color: "#232a31",
                }}
              >
                <Button
                  variant="text"
                  size="large"
                  fullWidth
                  startIcon={<AddRounded className="thin-9" />}
                  // endIcon={<DownloadOutlined className
                  sx={{ fontWeight: 400 }}
                  // startIcon={<PersonAddOutlined className="thin" />}
                  onClick={() => {
                    arrayFields.push({});
                    setIndx(arrayFields.length); // Set index to the new item
                  }}
                >
                  Add Reimbursement Item
                </Button>
                {meta.touched && typeof meta.error === "string" && (
                  <div style={{ color: "red", marginTop: "4px" }}>
                    {meta.error}
                  </div>
                )}
              </Flx>
            </Box>
          );
        }}
      </FieldArray>
    </RffGroup>
  );
};

const RffDisplayItem = ({ type, secondary = false, name, emptyValue, sx }) => {
  const { values } = useFormState();

  if (type === "dollar") {
    return (
      <Txt secondary={secondary} sx={sx}>
        {formatDollar(get(values, name)) || emptyValue}
      </Txt>
    );
  }
  return (
    <Txt secondary={secondary} sx={sx}>
      {get(values, name) || emptyValue}
    </Txt>
  );
};

const LineItemEditingCard = ({ name, index, onClose }) => {
  const fieldName = `${name}[${index}]`;
  const { values } = useFormState();
  return (
    <Card
      key={fieldName}
      sx={{
        position: "relative",
        flexGrow: 1,
        // overflow: "hidden",
        border: "1px solid rgba(221, 224, 228, 0.77)",
        // borderRadius: "4px",
        p: 2,
        // py: 4,
        backgroundColor: "#fff",
        mt: 2,
        // pb: 2,
      }}
    >
      <Flx fw ac jb gap={1} sx={{ mb: 1 }}>
        <Flx fw ac gap={1}>
          <EditNoteOutlined sx={{ fontSize: "16px" }} />
          <Txt sx={{ fontWeight: 600 }}>
            Edit Item: {get(values, fieldName)?.itemName}
          </Txt>
        </Flx>
        {isFunction(onClose) ? (
          <Tooltip title="Close Line Item Editor">
            <IconButton onClick={onClose}>
              <CloseOutlined fontSize="small" className="thin" />
            </IconButton>
          </Tooltip>
        ) : null}
      </Flx>
      <LineItemGroup>
        <RffTextField
          name={`${fieldName}.itemName`}
          label="Item Name"
          placeholder="Enter item name"
        />
        <RffTextareaField
          name={`${fieldName}.description`}
          label="Description"
          // size={6}
          minHeight={"60px"}
          placeholder="Enter a description of the item"
        />
        <RffNumberField
          name={`${fieldName}.quantityRequired`}
          label="Item Quantity"
          placeholder="Enter item quantity"
          size={4}
        />

        <RffDollarField
          name={`${fieldName}.unitPrice`}
          label="Per Unit Price"
          placeholder="Enter unit price of item"
          size={4}
        />
        <RffDollarField
          name={`${fieldName}.costPerSquareFoot`}
          label="Cost Per Square Foot (if applicable)"
          size={4}
        />
      </LineItemGroup>
      <LineItemGroup bt>
        <RffSelectToggleField
          name={`${fieldName}.itemCategory`}
          // size={8}
          label="Item Category"
          options={[
            "Bathroom",
            "Electrical",
            "Flooring",
            "Foundation",
            "Framing",
            "HVAC",
            "Landscaping",
            "Kitchen",
            "Windows",
          ]}
        />
        <RffSelectToggleField
          name={`${fieldName}.costCategory`}
          // size={4}
          label="Cost Category"
          options={["Hard Costs", "Soft Costs"]}
        />
      </LineItemGroup>
    </Card>
  );
};

const LineItemGroup = ({ children, bt, bb }) => {
  return (
    <RffGroup
      suppressBottomMargin
      columnSpacing={2}
      rowSpacing={3}
      sx={{
        mt: bt ? 4 : 0,
        pt: bt ? 3 : 0,
        borderTop: bt ? "2px dashed #dde0e4" : "none",
        borderBottom: bb ? "2px dashed #dde0e4" : "none",
      }}
    >
      {children}
    </RffGroup>
  );
};

const initTest = {
  reimbursementItemsRequested: [
    {
      description:
        "Professional grade lumber for framing the main structure and load-bearing walls",
      itemName: "2x4 Pressure Treated Lumber",
      quantityRequired: 150,
      unitPrice: 8.47,
    },
    {
      description:
        "High-efficiency HVAC system installation including ductwork and ventilation components",
      itemName: "Central Air Conditioning Unit",
      quantityRequired: 1,
      unitPrice: 3250.0,
    },
    {
      description:
        "Ceramic tile flooring for kitchen and bathroom areas with waterproof backing",
      itemName: "Premium Ceramic Floor Tiles",
      quantityRequired: 85,
      unitPrice: 12.95,
    },
    {
      description:
        "Professional electrical work including outlet installation and circuit panel upgrades",
      itemName: "Electrical Installation Services",
      quantityRequired: 8,
      unitPrice: 125.0,
    },
  ],
};

export default LoanDrawRequestForm;
